export const LOTTIE_SCRIPT_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.9.1/lottie.min.js';
